<template>
  <div class="inner-main">
    <div class="header">
      <span class="iconfont iconarrowleft-outline back-info"
        @click="goBack"></span>
    </div>
    <div class="main">
      <div class="fundding">
        <div class="news-title">
          {{$t("fundingEvent")}}
        </div>
        <div class="filter">
          <div id="investment-time-filter1"
            class="left"
            @click="showSearch(1)">投资时间
            <i class="iconfont icondown-chevron-outline "></i>
          </div>
         
          <div id="investment-round-filter1" class="investment-round-filter1 center" 
            @click="showSearch(3)">投资阶段 <i class="iconfont icondown-chevron-outline"></i></div>
          <div id="industry-filter3" class="industry-filter3 right"
            @click="showSearch(2)">所在领域 <i class="iconfont icondown-chevron-outline"></i></div>
          <van-popup v-model="showSearchPanel1"
            position="right"
            :style="{ height: '100%', width: '80%' }">
            <search-panel :type="orgListFunding1"
              @search="searchByPanel"></search-panel>
          </van-popup>

          <van-popup v-model="showSearchPanel2"
            position="right"
            :style="{ height: '100%', width: '80%' }">
            <search-panel :type="orgListFunding2"
              @search="searchByPanel"></search-panel>
          </van-popup>
          <van-popup v-model="showSearchPanel3"
            position="right"
            :style="{ height: '100%', width: '80%' }">
            <search-panel :type="orgListFunding3"
              @search="searchByPanel"></search-panel>
          </van-popup>
        </div>
        <van-list v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">

          <div class="item"
            v-for="item2 in dataList"
            :key="item2.id">
            <div class="info">
              <div class="top">
                <div class="dot"></div>
                <div class="name">
                  {{item2.company.name}}
                </div>
              </div>
              <div class="content">
                <div class="desc">
                  <span>公司简介：</span>
                  <span> {{item2.company.introduction}}</span>
                </div>
                <div class="field">
                  <span>所在领域：</span>
                  <span>
                    <span v-for="fd in industryFieldArr(item2.company.industryField)"
                      :key="fd">
                      {{fd}}
                    </span>
                  </span>
                </div>
                <div class="area">
                  <span>地区：</span>
                  <span v-if="item2.company.isAdd">{{item2.company.region}}</span>
                  <span v-else>{{item2.company.city}}{{item2.company.district}}</span>
                </div>
                <div class="invest">
                  <div class="left">
                    <div class="key">投资时间</div>
                    <div class="value">{{getDate(item2.fundingDate)}}</div>
                  </div>
                  <div class="center">
                    <div class="key">投资阶段</div>
                    <div class="value">{{item2.round}}</div>
                  </div>
                  <div class="right">
                    <div class="key">获投金额</div>
                    <div class="value" v-if="item2.investment">{{formatChineseAmount(item2.investment,item2.currency)}}</div>
                    <div class="value" v-else>{{formatDollar(item2.investmentDollar)}}</div>

                  </div>
                </div>
                <div class="invest2">
                  <div class="center">
                    <div class="key">投资方</div>
                    <div class="value">{{item2.investors}}</div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import webService from "@network/webService";
import common from "@common/common";
import formatter from "@common/formatter";
import SearchPanel from "@components/common/SearchPanel";

export default {
  data () {
    return {
      loading: false,
      finished: false,
      dataList: [],
      currentPage: 0,
      showSearchPanel1: false,
      showSearchPanel2: false,
      showSearchPanel3: false,
      orgListFunding1: common.searchTypeEnum.orgListFunding1,
      orgListFunding2: common.searchTypeEnum.orgListFunding2,
      orgListFunding3: common.searchTypeEnum.orgListFunding3,
      oldSearchModel: {},
      isDesc: true,
      isUp: false,
      tab: 0
    };
  },

  components: {
    SearchPanel,
  },

  computed: {},

  mounted () { },

  methods: {
    changeTimeOrder () {
      this.isDesc = !this.isDesc;
      this.isUp = !this.isUp;
      this.currentPage = 0;
      this.dataList = [];
      this.onLoad();
    },
    showSearch (num) {
      this.tab = num;
      switch (num) {
        case 1:
          this.showSearchPanel1 = true;
          break;
        case 2:
          this.showSearchPanel2 = true;
          break;

        case 3:
          this.showSearchPanel3 = true;
          break;
      }
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) { 
        if (this.tab === 1) {
          document.getElementById('investment-time-filter1').classList.add('has-filter');
        } else if (this.tab === 2) {
          document.getElementById('industry-filter3').classList.add('has-filter');
        } else if (this.tab === 3) {
          document.getElementById('investment-round-filter1').classList.add('has-filter');
        }
      } else {
        if (this.tab === 1) {
          document.getElementById('investment-time-filter1').classList.remove('has-filter');
        } else if (this.tab === 2) {
          document.getElementById('industry-filter3').classList.remove('has-filter');
        } else if (this.tab === 3) {
          document.getElementById('investment-round-filter1').classList.remove('has-filter');
        }
      }
      this.currentPage = 0;
      this.dataList = [];
      if (this.tab == 1) {
        this.oldSearchModel.InvestmentDate =
          searchParams.InvestmentDate;
      }
      if (this.tab == 2) {
        this.oldSearchModel.OrgIndustry = searchParams.OrgIndustry;
      }

      if (this.tab == 3) {
        this.oldSearchModel.OrgStage = searchParams.OrgStage;
      }
      this.showSearchPanel1 = false;
      this.showSearchPanel2 = false;
      this.showSearchPanel3 = false;
      this.onLoad();
    },
    onLoad () {
      var id = this.$route.query.id;
      var param = {
        PageSize: 20,
        Page: this.currentPage,
        OrgStage: this.oldSearchModel.OrgStage,
        OrgIndustry: this.oldSearchModel.OrgIndustry,
        InvestmentDate: this.oldSearchModel.InvestmentDate,
        OrderType: this.isDesc ? 2 : 1,
      };
      webService.getFundingList(id, param).then((res) => {
        console.log(res);
        for (let i = 0; i < res.data.length; i++) {
          this.dataList.push(res.data[i]);
        }
        this.loading = false;
        // debugger;
        if (res.data.length <= 0) {
          this.finished = true;
        }
        this.currentPage++;
      });
    },
    goBack () {
      this.$router.go(-1);
    },
    industryFieldArr (fields) {
      // debugger;
      if (fields) {
        return _.split(fields, ",", 4);
      } else {
        return [];
      }
    },
    getSubContent (cont) {
      let contentsArr = JSON.parse(cont);
      for (let i = 0; i < contentsArr.length; i++) {
        let obj = contentsArr[i];
        if (common.isEmpty(obj.image) && !common.isEmpty(obj.content)) {
          return obj.content;
        }
      }
    },
    getDate (date) {
      if (!common.isEmpty(date)) {
        return this.$moment(date).format("yyyy/MM/DD");
      } else {
        return "None";
      }
    },
    goNewsDetail (id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id: id,
          type: 0,
        },
      });
    },
    formatCurrency (val) {
      return formatter.formatCurrency(val);
    },
    formatChineseAmount (val, currency) {
      return formatter.formatChineseAmount(val, currency);
    },
    formatDollar (val) {
      return formatter.formatChineseAmount(val, "USD");
    },
  },
};
</script>

<style lang='less' scoped>
.inner-main {
  height: 100%;
}

.main {
  height: calc(100% - 63px);
}
.header {
  padding: 1rem;
  padding-bottom: 10px;
}
.back-info {
  font-size: 34px;
  color: #7d7d7d;
}
.fundding {
  height: calc(100% - 63px);
}
/deep/ .van-list {
  height: calc(100% - 63px);
  overflow: auto;
  padding-top: 30px;
}

.fundding {
  .news-title {
    padding: 0.25rem 1.125rem 1rem 1.125rem;
    margin-bottom: 30px;
    margin-bottom: 10px;
    font-size: 26px;
    color: #2d2d2d;
    font-weight: 550;
  }
  .filter {
    display: flex;
    border-bottom: 1px solid #dedede;
    margin-bottom: 8px;
    color: #7d7d7d;
    padding: 0 1.125rem 0.5rem 1.125rem;
    .left {
      flex: 1;
    }
    .center {
      flex: 1;
      text-align: center;
    }
    .right {
      flex: 1;
      text-align: right;
    }
  }

  .item {
    padding: 1.125rem;
    padding-top: 20px;
  }
  .item {
    margin: 1.125rem;
    border-left: 1px solid #dedede;
    .info {
      padding: 0.625rem 0.625rem 0.625rem 0.625rem;
      position: relative;
      .top {
        position: absolute;
        display: flex;
        top: -33px;
        left: -23px;
        width: 100%;
        .dot {
          background: #c52a1a;
          border-radius: 50%;
          height: 0.625rem;
          width: 0.625rem;
          // left: 0;
          // top: 7px;
          // transform: translateX(-50%);
        }
        .name {
          position: absolute;
          left: 16px;
          top: -7px;
          font-size: 16px;
          font-weight: bold;
          color: #464646;
          width: 100%;
        }
      }
      .content {
        .desc,
        .field,
        .area {
          line-height: 30px;
          font-size: 14px;
          color: #464646;
        }

        .invest,
        .invest2 {
          margin-top: 16px;
          margin-bottom: 16px;
          display: flex;
          .left,
          .center,
          .right {
            flex: 1;
          }
          .key {
            color: #7d7d7d;
            font-size: 12px;
            margin-bottom: 8px;
          }
          .value {
            font-size: 14px;
            color: #000000;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/content/org/ListFunding.vue